"use strict";

import { ItemListingState, ItemListingConfig, itemListingConfigModifier } from "./listing-helper";
import Toolbox from "./toolbox";
import ListingCacheHandler from "./listing-cache-handler";
import ListingAnalyticsHelper from "./listing-analytics";
import ListingFilterHandler from "./listing-filter-handler";
import ItemListingListenersHandler from "./listing-listener-handler";



let _state = {};
let _config = {};
const handlers = {};

const Actions = {
	init: (state, config, customWorkers) => {
		_state = state || ItemListingState;
		_config = config || ItemListingConfig;
		handlers.cacheHandler = ListingCacheHandler;
		handlers.analyticsHelper = ListingAnalyticsHelper;
		handlers.filterHandler = ListingFilterHandler;
		handlers.listeners = ItemListingListenersHandler;

		if (typeof customWorkers === "object" && customWorkers) {
			for (const key of Object.keys(customWorkers)) {
				handlers[key] = customWorkers[key];
			}
		}

		Actions.setTabIndex(_config.mobileFilterBarSelector + " [tabindex]", -1);
		window.addEventListener("load", () => {
			Actions.adjustFilters(true);
		});
		Actions.updateRemainingProductCount();
	},
	resetDropDowns: () => {
		const selector = ".component[data-type=dropdown], .component[data-type=fulldropdown]";
		const drops = document.querySelectorAll(selector);
		for (const element of drops) {
			Toolbox.closest(element, selector).classList.remove("dropdown-down");
		}
		document.querySelector(".bar-dropdown-view").classList.remove("dropdown-visible");
		handlers.listeners.removeBlurListener(handlers.listeners.dropdownBlur);
	},

	setTabIndex: (selector, tindex) => {

		for (const element of document.querySelectorAll(selector)) {
			element.tabIndex = tindex;
		}
	},

	/**
	 * Moves filters under "Tarkenna hakua".
	 * 
	 * @param {boolean} rebuildCache - Should be done when when adjusting filters after initial page load or if cache has been built.
	 */
	adjustFilters: (rebuildCache) => {

		if (_state.filtersMoved === false && _state.dataSourceWorkset && _state.viewOptionsWorkset && _state.viewOptionsWorkset.visibleFilters) {
			const filtersWidth = () => {
				return [].slice.call(document.querySelectorAll(_config.filterBarSelector + " .component-dropdown[data-type=fulldropdown]")).reduce((width, e) => {
					width += e.getBoundingClientRect().width + parseFloat(window.getComputedStyle(e).marginRight) + parseFloat(window.getComputedStyle(e).marginLeft);
					return width;
				}, 0);
			};

			if (filtersWidth() > _config.filterCutoffWidth) {
				if (_state.dataSourceWorkset.options === undefined) {
					_state.dataSourceWorkset.options = [];
				}

				const moveFilter = function (filter) {
					if (_state.dataSourceWorkset[filter.id]) {
						if (filter) {

							for (const element of document.querySelectorAll(_config.filterBarSelector + " .component-dropdown[data-filter=\"" + filter.id + "\"]")) {
								element.parentNode.removeChild(element);
							}

							for (const accordionElement of document.querySelectorAll(_config.mobileFilterBarSelector + " .component-accordion[data-filter=\"" + filter.id + "\"]")) {
								accordionElement.dataset.options = "true";
							}
							_state.dataSourceWorkset.options.unshift({
								id: filter.id, source: filter.source, isOption: true, name: filter.name, template: filter.template, values: _state.dataSourceWorkset[filter.id].map(item => {
									item.id = filter.id + "|:|" + item.id;
									return item;
								})
							});


						}
					}
				};

				for (const filter of _state.viewOptionsWorkset.visibleFilters.slice().reverse()) {
					moveFilter(filter);
					if (filtersWidth() <= _config.filterCutoffWidth) {
						_state.filtersMoved = true;
						if (rebuildCache === true) {
							handlers.cacheHandler.resetCache();
							handlers.cacheHandler.buildCache();
						}
						break;
					}
				}

			}
		}

	},

	handleAccordionOptions: () => {

		let values = [];
		let selected = [];

		for (const optionAccordion of document.querySelectorAll(_config.mobileFilterBarSelector + " .component-accordion[data-options=\"true\"]")) {
			const elementValue = optionAccordion.dataset.value ? JSON.parse(optionAccordion.dataset.value) : [];
			const elementSelected = optionAccordion.dataset.selected ? JSON.parse(optionAccordion.dataset.selected) : [];
			values = values.concat(elementValue);
			selected = selected.concat(elementSelected);

		}

		for (const optionElement of document.querySelectorAll(_config.mobileFilterBarSelector + " .component[data-filter=\"options\"], .filter-bar .component[data-filter=\"options\"]")) {
			optionElement.dataset.value = JSON.stringify(values);
			optionElement.dataset.selected = JSON.stringify(selected);
		}

	},
	closeAccordions: (clickedAccordion, all) => {
		for (const accordion of document.querySelectorAll(_config.mobileFilterBarSelector + " .component[data-type=accordion], " + _config.mobileFilterBarSelector + " .component[data-type=simpleaccordion]")) {

			if ((clickedAccordion && !clickedAccordion.classList.contains("accordion-visible")) || all === true) {
				accordion.classList.remove("accordion-visible");
				accordion.querySelector(".view-wrapper").style.height = "";
			}
		}
	},
	calculateBarDropdownHeight: (filterBarDropdown) => {
		const filterViewHeight = filterBarDropdown.querySelector(".view");
		if (filterViewHeight) {

			if (filterViewHeight.offsetHeight >= _config.desktopDropdownViewMaxHeight) {
				filterBarDropdown.style.height = _config.desktopDropdownViewMaxHeight + "px";
				filterBarDropdown.style.maxHeight = _config.desktopDropdownViewMaxHeight + "px";
				filterBarDropdown.style.overflow = "auto";
			} else {
				filterBarDropdown.style.maxHeight = "";
				filterBarDropdown.style.height = filterViewHeight.offsetHeight + "px";
				filterBarDropdown.style.overflow = "";
			}
		}
	},
	restoreOptionsAccordionValues: () => {
		const optionsFilter = document.querySelector(_config.filterBarSelector + " .component[data-filter=\"options\"]");
		const optionsValues = optionsFilter.dataset.value ? JSON.parse(optionsFilter.dataset.value) : [];
		for (const accElem of document.querySelectorAll(_config.mobileFilterBarSelector + " .component-accordion[data-options=\"true\"]")) {
			accElem.dataset.value = "";
			accElem.dataset.selected = "";
		}

		const accordionValues = {};
		for (const a of optionsValues) {
			const mappedOption = handlers.cacheHandler.cache.dataSourceById.options[a];
			if (accordionValues[mappedOption.optionsGroup] === undefined) {
				accordionValues[mappedOption.optionsGroup] = { values: [], selected: [] };
			}
			accordionValues[mappedOption.optionsGroup].values.push(mappedOption.id);
			accordionValues[mappedOption.optionsGroup].selected.push(mappedOption.name);
		}

		for (const key of Object.keys(accordionValues)) {
			const accordionState = accordionValues[key];
			const accrd = document.querySelector(_config.mobileFilterBarSelector + " .component-accordion[data-id=\"" + key + "\"]");
			accrd.dataset.value = JSON.stringify(accordionState.values);
			accrd.dataset.selected = JSON.stringify(accordionState.selected);

		}

	},
	filterMenuToggle: () => {
		Actions.closeAccordions(false, true);

		const filterMenu = _config.mobileFilterBar;
		if (filterMenu.classList.contains("menu-visible")) {
			Actions.setTabIndex(_config.mobileFilterBarSelector + " [tabindex]", -1);
			filterMenu.classList.remove("menu-visible");
			//componentWait(function () { saveFilterState(getFilterState()) });
			handlers.listeners.removeBlurListener(handlers.listeners.filterMenuBlur);
		} else {
			Actions.setTabIndex(_config.mobileFilterBarSelector + " [tabindex]", 0);
			filterMenu.classList.add("menu-visible");
			Actions.resetDropDowns();
			handlers.listeners.addBlurListener(handlers.listeners.filterMenuBlur);
		}

		Actions.cleanHiddenViews();
	},
	restoreDefaultFilters: () => {
		// BD analytics start
		if (_config.useCampaignAnalytics) {
			handlers.analyticsHelper.selectFilterEvent("Poista kaikki rajaukset");
		}
		// BD analytics end
		handlers.filterHandler.restoreFilters(_config.defaultFilterState);
		handlers.filterHandler.saveFilterState(handlers.filterHandler.getFilterState());
	},
	setNextPage: (np) => {

		if (!_state.done) {
			if (np === undefined) {
				_state.nextPage = 2;
			} else {
				_state.nextPage = np;
			}
			document.querySelector(_config.loadMoreLink).href = "?page=" + _state.nextPage;
		} else {
			document.querySelector(_config.loadMoreLink).href = "#";
		}

	},
	cleanHiddenViews: () => {

		Toolbox.waitForFinalEvent(() => {
			for (const accordion of document.querySelectorAll(".component[data-type=accordion]")) {

				if (!accordion.classList.contains("accordion-visible")) {
					const accordionView = accordion.querySelector(".view-wrapper");
					while (accordionView.firstChild) {
						accordionView.removeChild(accordionView.firstChild);
					}
				}
			}
		}, 400, "accordionclean");

		Toolbox.waitForFinalEvent(() => {
			for (const dpwn of document.querySelectorAll(".component[data-type=dropdown]")) {
				if (!dpwn.classList.contains("dropdown-down")) {
					const dpwnView = dpwn.querySelector(".dropdown-menu");
					while (dpwnView.firstChild) {
						dpwnView.removeChild(dpwnView.firstChild);
					}
				}
			}
		}, 400, "dropdownclean");

		Toolbox.waitForFinalEvent(() => {
			const dpwn = document.querySelector(".filter-bar .bar-dropdown-view");

			if (dpwn) {
				if (!dpwn.classList.contains("dropdown-visible")) {
					while (dpwn.firstChild) {
						dpwn.removeChild(dpwn.firstChild);
					}
				}
			}

		}, 400, "fulldropdownclean");
	},
	updateListingCount: (count) => {
		for (const productCountElement of document.querySelectorAll(_config.listingItemCountSelector)) {
			productCountElement.textContent = count;
		}
		for (const productCountElement of document.querySelectorAll(_config.listingItemCountWithTextSelector)) {
			productCountElement.textContent = Number(count) === 1 ? _config.listingItemType : _config.listingItemTypePlural;
		}


		const mobileMenu = document.querySelector(_config.mobileFilterBarSelector);
		if (mobileMenu) {
			if (parseInt(count) < 1) {
				mobileMenu.classList.add("no-results");
			} else {
				mobileMenu.classList.remove("no-results");
			}
		}


		Actions.updateRemainingProductCount(count);
	},

	updateRemainingProductCount: (count) => {

		if (count === undefined) {
			count = Actions.getItemCount();
		}
		const remainingProductCountElements = document.querySelectorAll(_config.listingRemainingItemsCountSelector);
		const remainingCount = Math.max((count - (_state.currentIndex + _state.itemsPerPage)), 0);
		for (const remainingProductCountElement of remainingProductCountElements) {
			remainingProductCountElement.textContent = remainingCount;
		}

	},

	getItemCount: () => {
		const productCountElement = document.querySelector(_config.listingItemCountSelector);

		if (productCountElement) {
			return parseInt(productCountElement.textContent);
		} else {
			return 0;
		}
	}
};

export default Actions;